







import Vue from 'vue'

export default Vue.extend({
  name: 'Background',
  data: () => ({
    src: require('../assets/background.jpg'),
  }),
  mounted() {
    const image = this.$refs.image as HTMLImageElement
    const background = this.$refs.background as HTMLDivElement
    image.addEventListener('load', () => {
      setTimeout(() => {
        background.classList.remove('blur')
        background.style.backgroundImage = `url(${this.src})`
      }, 1000)
    })
    image.src = this.src
  },
})
